import { apiWithToken } from './api';
import { API_ENDPOINTS } from '../config/apiUrls';
import { decodeData } from '../helpers/function_helper';

export const pnrService = {
  // Lấy danh sách hãng bay
  getAirlineList: async (params) => {
    try {
      const response = await apiWithToken.get(API_ENDPOINTS.AIRLINE_LIST, { params });
      return decodeData(response.data);
    } catch (error) {
      if (error.response?.data) {
        const result = decodeData(error.response.data);
        if (result.code === 401) {
          throw error;
        }
        return result;
      }
      throw error;
    }
  },

  // Tìm kiếm PNR
  searchPNR: async (searchData) => {
    try {
      const response = await apiWithToken.post(API_ENDPOINTS.PNR_SEARCH, searchData);
      return decodeData(response.data);
    } catch (error) {
      if (error.response?.data) {
        const result = decodeData(error.response.data);
        if (result.code === 401) {
          throw error;
        }
        return result;
      }
      throw error;
    }
  },

  // Cập nhật trạng thái vé (khoá/mở khoá)
  updateTicketStatus: async (updateData) => {
    try {
      const response = await apiWithToken.post(API_ENDPOINTS.UPDATE_TICKET_STATUS, updateData);
      return decodeData(response.data);
    } catch (error) {
      if (error.response?.data) {
        const result = decodeData(error.response.data);
        if (result.code === 401) {
          throw error;
        }
        return result;
      }
      throw error;
    }
  },

  // Khoá PNR (legacy - giữ để tương thích)
  lockPNR: async (pnrData) => {
    return await this.updateTicketStatus({
      ...pnrData,
      is_lock: 1
    });
  },

  // Mở khoá PNR (legacy - giữ để tương thích)
  unlockPNR: async (pnrData) => {
    return await this.updateTicketStatus({
      ...pnrData,
      is_lock: 0
    });
  },

  // Kiểm tra trạng thái PNR (legacy - giữ để tương thích)
  checkPNRStatus: async (pnrCode) => {
    return await this.searchPNR({ ma_dat_cho: pnrCode });
  }
};